/* Photos remain usable without JavaScript; automatic reels load when visible. */
if (!customElements.get('piex-motion')) {
  customElements.define('piex-motion', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplay = this.dataset.autoplay === 'true';
      this.visibleCards = new Set();
      this.paused = this.motion.matches || Boolean(window.Shopify?.designMode);
      this.querySelectorAll('.piex-reel__playback').forEach(controls => { controls.hidden = this.autoplay; });
      this.updateRibbons();
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        const card = button.closest('.piex-reel');
        if (!card) return;
        if (button.hasAttribute('data-reel-play')) this.toggleVideo(card);
        if (button.hasAttribute('data-reel-mute')) {
          const video = this.videoFor(card);
          video.muted = !video.muted;
          button.setAttribute('aria-pressed', String(!video.muted));
          button.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar vídeo');
        }
      }, options);
      this.motion.addEventListener('change', () => {
        this.paused = this.motion.matches || Boolean(window.Shopify?.designMode);
        this.updateRibbons();
      }, options);
      this.visibility = () => {
        const hidden = document.hidden || document.documentElement.dataset.piexMode !== this.dataset.mode;
        this.dataset.offscreen = String(hidden || !this.inView);
        if (hidden) this.pauseVideos();
        if (this.autoplay) this.syncAutoplay();
      };
      document.addEventListener('visibilitychange', this.visibility, options);
      this.modeObserver = new MutationObserver(this.visibility);
      this.modeObserver.observe(document.documentElement, {attributes:true, attributeFilter:['data-piex-mode']});
      if (this.autoplay) this.modeObserver.observe(this, {attributes:true, subtree:true, attributeFilter:['open']});
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === this) {
            this.inView = entry.isIntersecting;
            this.visibility();
          } else {
            if (entry.isIntersecting) this.visibleCards.add(entry.target);
            else {
              this.visibleCards.delete(entry.target);
              entry.target.querySelector('video')?.pause();
            }
          }
        });
        if (this.autoplay) this.syncAutoplay();
      }, {threshold:0.1});
      this.observer.observe(this);
      this.querySelectorAll('.piex-reel').forEach(card => this.observer.observe(card));
    }
    updateRibbons() {
      this.dataset.paused = String(this.paused);
      if (this.autoplay && this.dataset.mode === 'halloween') this.syncAutoplay();
    }
    videoFor(card) {
      let video = card.querySelector('video');
      if (!video) {
        card.querySelector('.piex-reel__media').append(card.querySelector('[data-reel-video]').content.cloneNode(true));
        video = card.querySelector('video');
        if (this.autoplay) {
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
          video.playsInline = true;
          video.controls = false;
          video.autoplay = true;
        }
        const update = () => {
          const playing = !video.paused;
          const button = card.querySelector('[data-reel-play]');
          if (!button) return;
          button.setAttribute('aria-pressed', String(playing));
          const name = card.querySelector('.piex-reel__product strong').textContent;
          button.setAttribute('aria-label', (playing ? 'Pausar vídeo: ' : 'Reproducir vídeo: ') + name);
          card.querySelector('[data-play-icon]').hidden = playing;
          card.querySelector('[data-pause-icon]').hidden = !playing;
        };
        video.addEventListener('play', update, {signal:this.abort.signal});
        video.addEventListener('pause', update, {signal:this.abort.signal});
      }
      return video;
    }
    syncAutoplay() {
      if ((this.dataset.mode === 'halloween' && this.paused) || document.hidden || !this.inView || document.documentElement.dataset.piexMode !== this.dataset.mode || this.querySelector('dialog[open]')) {
        this.pauseVideos();
        return;
      }
      this.visibleCards.forEach(card => {
        if (!card.querySelector('[data-reel-video]')) return;
        const video = this.videoFor(card);
        if (!video.paused) return;
        video.muted = true;
        const status = card.querySelector('.piex-reel__status');
        status.textContent = '';
        video.play().catch(error => {
          if (error.name !== 'AbortError' && error.name !== 'NotAllowedError') status.textContent = 'El vídeo no está disponible. Puedes ver el producto.';
        });
      });
    }
    async toggleVideo(card) {
      const video = this.videoFor(card);
      if (!video.paused) { video.pause(); return; }
      document.querySelectorAll('piex-motion video').forEach(other => { if (other !== video) other.pause(); });
      const status = card.querySelector('.piex-reel__status');
      status.textContent = '';
      try { await video.play(); }
      catch (error) {
        // Pausing a pending play (another reel, a modal or a hidden section) is intentional.
        if (error.name !== 'AbortError') status.textContent = 'El vídeo no está disponible. Puedes ver el producto.';
      }
    }
    pauseVideos() { this.querySelectorAll('video').forEach(video => video.pause()); }
    disconnectedCallback() {
      this.pauseVideos();
      this.abort?.abort();
      this.observer?.disconnect();
      this.modeObserver?.disconnect();
    }
  });
}
